import { useQuery } from "@tanstack/react-query";

import { getPartner } from "services";

import { GET_PARTNER } from "consts";

import { Partner } from "models";

export const useGetPartner = (id: string) =>
  useQuery<Partner>({
    queryKey: [GET_PARTNER, id],
    queryFn: () => getPartner({ id }),
    enabled: !!id,
    refetchOnMount: "always",
  });
